<template>
  <div>
    <please-wait-modal/>
    <p>Total Point : {{ data_user.arr_point != null && data_user.arr_point.length > 0 ? data_user.arr_point[0].total : 0 }}</p>
    <custom-table :arr="data_point.arr" :total_page="data_point.total_page" :arr_header="data_point.arr_header" @on_refresh_start="on_refresh_start" @on_refresh_end="on_refresh_end"/>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'
import SkeletonBox from '@/layout/skeleton'

export default {
  components:{
    'custom-table': custom_table,
    'please-wait-modal': please_wait_modal,
    'table-skeleton': table_skeleton,
    'skeleton-box': SkeletonBox,
  },
  props: ['data_user'],
  data(){
    return{
      data_point: {
        arr:[],
        arr_header: [],
        total_page: 1,
      },
    }
  },
  watch: {
    data_user(val){
      if(val.id != null)
        this.get_data()
    }
  },
  created(){
    if(this.data_user.id != null)
      this.get_data()
  },
  methods: {
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){
      var response = await axios.get(base_url+'/point/detail?api_type=web-admin&point_id='+(this.data_user.arr_point.length > 0 ? this.data_user.arr_point[0].id : ''))

      var response_data = response.data

      if(response_data.status == "success"){
        this.data_point.arr = response_data.arr
        this.data_point.arr_header = response_data.arr_header
        this.data_point.arr_id = response_data.arr_id
        this.data_point.total_page = response_data.total_page
      }
      else
        this.$toasted.show(response_data.message)
    },
  }
}
</script>
